import React, { FC } from 'react';

import { CommunicationPanelProps } from './communicationPanel.types';
import * as S from './communicationPanel.styles';
import { BrandPageBackground } from '../BrandPageBackground';
import { HelpFooter } from '../HelpFooter';
import { TitledMessage } from '../TitledMessage';
import { Spinner } from '../Spinner';

const CommunicationPanel: FC<CommunicationPanelProps> = ({
  backgroundGradient,
  backgroundImage,
  brandLogo,
  brandName,
  panelPosition,
  showFooter = true,
  title,
  text,
  mode,
  children,
  loading = false,
}) => {
  const position = panelPosition || 'left';
  const brandLogoElement = (
    <S.CommunicationPanelLogoArea $mode={mode}>
      <img alt={brandName} src={brandLogo} />
    </S.CommunicationPanelLogoArea>
  );

  const loadingElement = (
    <>
      {brandLogoElement}
      <Spinner type="orbit" />
    </>
  );

  const containedElements = (
    <>
      {brandLogoElement}
      {title && (
        <TitledMessage title={title} titleAligned={mode === 'sidePanel' ? 'start' : 'center'}>
          {text || null}
        </TitledMessage>
      )}
      <S.CommunicationPanelScrollableArea $mode={mode}>
        <S.CommunicationPanelContentArea>{children}</S.CommunicationPanelContentArea>
      </S.CommunicationPanelScrollableArea>
      {showFooter && <HelpFooter />}
    </>
  );

  const align =
    mode === 'centered' ? panelPosition || 'left' : panelPosition === 'left' ? 'right' : 'left';

  return (
    <BrandPageBackground background={backgroundGradient} image={backgroundImage} align={align}>
      <S.CommunicationPanelContainer $panelPosition={position} $mode={mode}>
        {mode === 'sidePanel' ? (
          <>{loading ? loadingElement : containedElements}</>
        ) : (
          <S.CommunicationCenterPanelContainer>
            {loading ? loadingElement : containedElements}
          </S.CommunicationCenterPanelContainer>
        )}
      </S.CommunicationPanelContainer>
    </BrandPageBackground>
  );
};

export { CommunicationPanel };
